/* @sravni/react-design-system version 0.2.60 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { FONT_SIZES, CONTAINER_SIZES } from '../../../constants/sizes.js';
import '../../Typography/index.js';
import SizeContext from './SizeContext.js';
import modules_28f16a69 from '../styles/Avatar.module.less.js';
import { Text } from '../../Typography/src/Text.js';

var getTextSize = function (size) {
    switch (size) {
        case 36:
        case 44:
        case 52:
        default:
            return FONT_SIZES.S16;
        case 60:
            return FONT_SIZES.S20;
    }
};
/**
 * @description The Avatar component is used to represent users. And should only be used for avatars and logotypes
 *
 * @component
 * @example
 * ```jsx
 * <Avatar src="image.png" />
 * ```
 */
var Avatar = React.forwardRef(function (props, ref) {
    var _a;
    var groupSize = React.useContext(SizeContext);
    var size = props.size, src = props.src, className = props.className, children = props.children, restProps = __rest(props, ["size", "src", "className", "children"]);
    var cx = useStyles(modules_28f16a69);
    var classNames = cx(className, 'avatar', (_a = {},
        _a["size-" + (groupSize || size)] = size,
        _a));
    var content = React.useMemo(function () {
        if (src) {
            return React.createElement("img", { className: cx('image'), src: src, alt: "avatar", loading: "lazy" });
        }
        return (React.createElement(Text, { strong: true, uppercase: true, size: getTextSize(size) }, children));
    }, [src]);
    return (React.createElement("div", __assign({ ref: ref, "data-qa": "Avatar", className: classNames }, restProps), content));
});
Avatar.defaultProps = {
    size: CONTAINER_SIZES.S44,
};
Avatar.displayName = 'Avatar';

export default Avatar;
//# sourceMappingURL=Avatar.js.map
